import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { CgMicrosoft } from "react-icons/cg";
import "./AuthFooter.scss";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../logic/authConfig";
import api from "../.././../../core/utils/apis/api";
function AuthFooter({ title, loginMicrosoft }) {
  const navigate = useNavigate();

  const navigateToAuth = (title) => {
    return (e) => {
      e.preventDefault();
      navigate("/" + title);
    };
  };
  const { instance } = useMsal();
  
  const handleLogin = async (loginType) => {
    try {
      if (loginType === "popup") {
        const msRes = await instance.loginPopup(loginRequest);
        const res = await api.post(
          "/auth/sso",
          {},
          { headers: { Authorization: `Bearer ${msRes.accessToken}` } }
        );
        localStorage.setItem("accessToken", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        if (sessionStorage.getItem("lastPage")) {
          window.location.href = sessionStorage.getItem("lastPage");
          sessionStorage.removeItem("lastPage");
        } else {
          window.location.href = "/";
        }
      } else if (loginType === "redirect") {
        instance.loginRedirect(loginRequest).catch((e) => {
          console.log(e);
        });
      }
    } catch (error) {
      if (error.name === "BrowserAuthError" && error.errorCode === "user_cancelled") {
        // Handle user cancellation (e.g., show a message or perform specific actions)
        console.log("User cancelled the login flow.");
      } else {
        // Handle other errors
        console.error(error);
      }
    }
  };
  
  return (
    <div className="auth-footer">
      <button className="auth-button" type="submit">
        {title}
      </button>
      <div className="seperator">
        <p>or</p>
      </div>
      <div className="auth-options">
        <button type="button" className="button-google">
          <FcGoogle />
          {title} with Google
        </button>
        <button
          type="button"
          onClick={() => handleLogin("popup")}
          className="button-microsoft"
        >
          <CgMicrosoft />
          {title} with Microsoft
        </button>
      </div>
      {title !== "Register" ? (
        <p className="auth-link">
          Don't have an account?{" "}
          <span onClick={navigateToAuth((title = "register"))}>Register</span>
        </p>
      ) : (
        <p className="auth-link">
          Already have an account?{" "}
          <span onClick={navigateToAuth((title = "login"))}>Login</span>
        </p>
      )}
    </div>
  );
}
export default AuthFooter;
